export default __webpack_public_path__ + "static/media/trust-pilot.9dcd8638.png";